import api from "@/lib/axios";

export const permissionService = {
  async getAllPermissions() {
    const response = await api.get('/permissions');
    return response.data;
  },

  async getPermission(id) {
    const response = await api.get(`/permissions/${id}`);
    return response.data;
  },

  async createPermission(data) {
    const response = await api.post('/permissions', data);
    return response.data;
  },

  async updatePermission(id, data) {
    const response = await api.put(`/permissions/${id}`, data);
    return response.data;
  },

  async deletePermission(id) {
    const response = await api.delete(`/permissions/${id}`);
    return response.data;
  }
}; 